import { render, staticRenderFns } from "./AdminLog.vue?vue&type=template&id=4234d828"
import script from "./AdminLog.vue?vue&type=script&lang=js"
export * from "./AdminLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports